const blobUrlFormatHelper = (relativeUrl: string): string => {
  if (!relativeUrl) return "";

  //else create an actual server request url
  return "/api/Asset/" + relativeUrl;
};

export default blobUrlFormatHelper;
